import * as React from "react";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";

// event-missing
import { IProps } from "./EventMissing.d";
import { styles } from "./EventMissing.styles";

///////////////
// Component //
///////////////

class EventMissingComponent extends React.PureComponent<IProps, {}> {
  public render() {
    const { hideYourCalendar } = this.props;

    return (
      <div className={this.props.classes.container}>
        <div className={this.props.classes.eventMissingImage} />
        <Typography variant="h6" className={this.props.classes.h6}>
          The requested event could not be found, it may have been cancelled or removed
          {hideYourCalendar ? "" : " from your calendar"}.
        </Typography>
      </div>
    );
  }
}

/////////////////
// With Styles //
/////////////////

export const EventMissing = withStyles(styles)(EventMissingComponent);
